import React, { useEffect, useState, useCallback } from "react";
import { Modal } from "react-bootstrap";
import jsPDF from "jspdf";
import AddNewTimeLog from "./AddNewTimeLog";
import Moment from "react-moment";
import AddEditNotes from "./AddEditNotes";
import CandidatePay from "./CandidatePay";
import {
  formatTotalHours,
  formatAmount,
  getFieldData,
  getMonthLastDay,
  getMonthName,
  getTotalDays,
  getTotalHours,
} from "../../Services/appService";
import { getAlert, getConfirmAlert } from "../../Services/appAlerts";
import {
  getCurrentUser,
  getLoggedUserDetails,
  loadUserDetails,
} from "../../app/store/auth";
import { useDispatch, useSelector } from "react-redux";
import {
  getProjectDateUpdateStatus,
  getAllRates,
  getTimeLogReportStatus,
  getTimeLogDuration,
  getTimeLogs,
  getTimeSheetDelStatus,
} from "../../app/store/timeLog";
import {
  getTimeLogInvoice,
} from "../../app/store/timeLogInvoice";
import useDocDownload from "../../app/hooks/useDocDownload";
import RateEncryptDecrypt from "../../Services/RateEncryptDecrypt";
import { getCandidateAppAllTasks } from "../../app/store/candidate";
import {
  useLoadTimeLogsQuery,
  useLoadTimeLogDurationQuery,
  useLoadAllRatesQuery,
  useLoadTimeLogInvoiceQuery,
  useUpdateProjectStartDateMutation,
  useDeleteTimeSheetDocMutation,
  useSetTimeLogReportStatusMutation,
} from "../../app/store/timeLogApiSlice";

const TIME_LOG_STYLES = {
  card: {
    borderRadius: "22px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #fbfdff 100%)",
    boxShadow: "0 14px 34px rgba(15, 23, 42, 0.05)",
    overflow: "hidden",
  },
  cardHeader: {
    padding: "20px 22px 16px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
  },
  titleRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "14px",
    flexWrap: "wrap",
  },
  titleWrap: {
    display: "inline-flex",
    alignItems: "center",
    gap: "12px",
    minWidth: 0,
  },
  titleIcon: {
    width: "38px",
    height: "38px",
    borderRadius: "12px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
    color: "#1d4ed8",
    fontSize: "16px",
    border: "1px solid rgba(191, 219, 254, 1)",
  },
  title: {
    fontSize: "18px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "4px",
  },
  subtitle: {
    fontSize: "13px",
    lineHeight: 1.6,
    color: "#64748b",
    margin: 0,
  },
  primaryButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "8px 14px",
    fontSize: "12px",
    fontWeight: 700,
  },
  cardBody: {
    padding: "18px 22px 22px 22px",
  },
  statsRow: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "12px",
    marginBottom: "16px",
  },
  statCard: {
    borderRadius: "18px",
    padding: "14px 16px",
    background: "#ffffff",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    boxShadow: "0 10px 26px rgba(37, 99, 235, 0.06)",
  },
  statLabel: {
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    marginBottom: "6px",
  },
  statValue: {
    fontSize: "22px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.1,
  },
  statHint: {
    fontSize: "12px",
    lineHeight: 1.5,
    color: "#64748b",
    marginTop: "6px",
  },
  utilityRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    marginBottom: "14px",
  },
  utilityPanel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "14px",
    padding: "14px 16px",
    borderRadius: "18px",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
    boxShadow: "0 10px 24px rgba(37, 99, 235, 0.06)",
    width: "100%",
    flexWrap: "wrap",
  },
  utilityPanelTop: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flex: 1,
    minWidth: 0,
  },
  utilityIcon: {
    width: "36px",
    height: "36px",
    borderRadius: "12px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
    color: "#1d4ed8",
    border: "1px solid rgba(191, 219, 254, 1)",
    flexShrink: 0,
  },
  utilityCopy: {
    minWidth: 0,
    flex: 1,
  },
  utilityLabel: {
    fontSize: "11px",
    fontWeight: 800,
    color: "#64748b",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    margin: 0,
  },
  utilityValue: {
    fontSize: "16px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.2,
    marginTop: "2px",
  },
  utilityActions: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
  },
  utilityEditor: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flexWrap: "nowrap",
    marginLeft: "auto",
  },
  utilityInput: {
    minWidth: "160px",
    maxWidth: "240px",
  },
  utilityButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#334155",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700,
  },
  utilityPrimaryButton: {
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
  },
  utilityDangerButton: {
    color: "#475569",
  },
  tableWrap: {
    border: "1px solid rgba(226, 232, 240, 1)",
    borderRadius: "18px",
    overflow: "auto",
    backgroundColor: "#ffffff",
  },
  table: {
    marginBottom: 0,
  },
  tableHeadCell: {
    borderTop: "none",
    fontSize: "12px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    background: "#f8fafc",
    padding: "14px 16px",
    verticalAlign: "top",
  },
  tableHeadSubtext: {
    display: "block",
    fontSize: "10px",
    fontWeight: 700,
    letterSpacing: "0.04em",
    textTransform: "none",
    color: "#94a3b8",
    marginTop: "4px",
  },
  cell: {
    verticalAlign: "top",
    padding: "18px 16px",
    borderTop: "1px solid rgba(226, 232, 240, 0.75)",
    fontSize: "13px",
    color: "#0f172a",
  },
  chip: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "34px",
    padding: "0 12px",
    borderRadius: "999px",
    background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
    color: "#1d4ed8",
    fontSize: "13px",
    fontWeight: 800,
    border: "1px solid rgba(191, 219, 254, 1)",
    whiteSpace: "nowrap",
  },
  periodText: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 12px",
    borderRadius: "14px",
    background: "linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%)",
    border: "1px solid rgba(219, 234, 254, 1)",
    boxShadow: "inset 0 0 0 1px rgba(255, 255, 255, 0.7)",
    fontSize: "14px",
    fontWeight: 700,
    color: "#0f172a",
    marginBottom: "6px",
    cursor: "pointer",
  },
  periodIcon: {
    color: "#2563eb",
    fontSize: "13px",
  },
  metricButton: {
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "4px",
    padding: "8px 12px",
    borderRadius: "14px",
    background: "linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%)",
    border: "1px solid rgba(219, 234, 254, 1)",
    boxShadow: "inset 0 0 0 1px rgba(255, 255, 255, 0.7)",
    color: "#0f172a",
    cursor: "pointer",
    textAlign: "left"
  },
  metricPrimary: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    fontWeight: 800,
    lineHeight: 1.15,
    color: "#0f172a",
  },
  metricSecondary: {
    display: "block",
    color: "#64748b",
    fontSize: "14px",
    fontWeight: 800,
    lineHeight: 1.2,
  },
  metricStack: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  statusStack: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "7px",
  },
  statusPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "7px",
    minHeight: "30px",
    padding: "6px 11px",
    borderRadius: "999px",
    border: "1px solid transparent",
    fontSize: "12px",
    fontWeight: 700,
    lineHeight: 1.2,
    whiteSpace: "nowrap",
  },
  statusPending: {
    color: "#92400e",
    backgroundColor: "#fffbeb",
    borderColor: "rgba(253, 230, 138, 1)",
  },
  statusApproved: {
    color: "#166534",
    backgroundColor: "#f0fdf4",
    borderColor: "rgba(187, 247, 208, 1)",
  },
  statusRejected: {
    color: "#991b1b",
    backgroundColor: "#fef2f2",
    borderColor: "rgba(254, 202, 202, 1)",
  },
  statusReviewed: {
    color: "#1d4ed8",
    backgroundColor: "#eff6ff",
    borderColor: "rgba(191, 219, 254, 1)",
  },
  statusDate: {
    fontSize: "12px",
    color: "#64748b",
    lineHeight: 1.4,
  },
  docList: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  docRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "10px",
    padding: "8px 10px",
    border: "1px solid rgba(226, 232, 240, 1)",
    borderRadius: "14px",
    background: "#ffffff",
    boxShadow: "0 6px 14px rgba(15, 23, 42, 0.03)",
  },
  docLink: {
    border: "none",
    background: "transparent",
    color: "#2563eb",
    padding: 0,
    fontSize: "13px",
    fontWeight: 700,
    textAlign: "left",
    wordBreak: "break-word",
  },
  iconButton: {
    width: "30px",
    height: "30px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    boxShadow: "0 6px 14px rgba(15, 23, 42, 0.04)",
  },
  docUploadButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    marginTop: "10px",
    borderRadius: "999px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700,
    whiteSpace: "nowrap",
  },
  notesButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700,
  },
  notesBadge: {
    minWidth: "20px",
    height: "20px",
    borderRadius: "999px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#ffffff",
    color: "#0f172a",
    fontSize: "11px",
    fontWeight: 800,
    padding: "0 6px",
  },
  actionLink: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700,
  },
  actionStack: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "8px",
  },
  monthYearStack: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "3px",
  },
  monthYearPrimary: {
    fontSize: "14px",
    fontWeight: 800,
    color: "#0f172a",
  },
  monthYearSecondary: {
    fontSize: "12px",
    fontWeight: 700,
    color: "#64748b",
  },
  paymentBlock: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  paymentDate: {
    fontSize: "13px",
    fontWeight: 700,
    color: "#0f172a",
  },
  paymentText: {
    fontSize: "12px",
    color: "#475569",
  },
  reportButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700,
    whiteSpace: "nowrap",
  },
  reportGeneratedButton: {
    border: "1px solid rgba(187, 247, 208, 1)",
    background: "#f0fdf4",
    color: "#166534",
  },
  modalHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(239, 246, 255, 0.95) 100%)",
  },
  modalTitleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    width: "100%",
  },
  modalIcon: {
    width: "42px",
    height: "42px",
    borderRadius: "14px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
    color: "#1d4ed8",
    border: "1px solid rgba(191, 219, 254, 1)",
    flexShrink: 0,
  },
  modalTitle: {
    fontSize: "20px",
    fontWeight: 800,
    color: "#0f172a",
    margin: 0,
  },
  modalSubtitle: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px",
  },
  modalCloseButton: {
    width: "36px",
    height: "36px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "auto",
    flexShrink: 0,
  },
  modalBody: {
    padding: "20px 22px",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
  },
  reportSummaryGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))",
    gap: "12px",
  },
  reportSummaryCard: {
    borderRadius: "16px",
    padding: "14px",
    background: "#ffffff",
    border: "1px solid rgba(226, 232, 240, 1)",
    boxShadow: "0 10px 22px rgba(15, 23, 42, 0.04)",
  },
  reportSummaryLabel: {
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    marginBottom: "6px",
  },
  reportSummaryValue: {
    fontSize: "16px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.3,
  },
  reportPreviewCard: {
    marginTop: "16px",
    borderRadius: "18px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 12px 28px rgba(15, 23, 42, 0.05)",
    overflow: "hidden",
  },
  reportPreviewHeader: {
    padding: "16px 18px",
    borderBottom: "1px solid rgba(226, 232, 240, 1)",
    background: "#f8fafc",
  },
  reportPreviewTitle: {
    margin: 0,
    color: "#0f172a",
    fontSize: "16px",
    fontWeight: 800,
  },
  reportPreviewSubtitle: {
    margin: "5px 0 0",
    color: "#64748b",
    fontSize: "12px",
    lineHeight: 1.5,
  },
  reportMetricGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "12px",
    padding: "18px",
  },
  reportMetricCard: {
    position: "relative",
    minHeight: "112px",
    border: "1px solid rgba(226, 232, 240, 1)",
    borderRadius: "12px",
    background: "linear-gradient(180deg, #ffffff 0%, #fbfdff 100%)",
    padding: "16px 16px 14px 16px",
    overflow: "hidden",
    boxShadow: "0 10px 22px -18px rgba(15, 23, 42, 0.35)",
  },
  reportMetricAccent: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "4px",
  },
  reportMetricIcon: {
    width: "34px",
    height: "34px",
    borderRadius: "10px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid rgba(226, 232, 240, 1)",
    marginBottom: "12px",
  },
  reportMetricLabel: {
    marginBottom: "6px",
    color: "#64748b",
    fontSize: "10px",
    fontWeight: 850,
    letterSpacing: "0.07em",
    textTransform: "uppercase",
  },
  reportMetricValue: {
    color: "#0f172a",
    fontSize: "20px",
    fontWeight: 850,
    lineHeight: 1.15,
    wordBreak: "break-word",
  },
  reportMuted: {
    display: "block",
    marginTop: "4px",
    color: "#64748b",
    fontSize: "11px",
    lineHeight: 1.35,
  },
  modalFooter: {
    padding: "16px 22px",
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    background: "#ffffff",
  },
  modalFooterActions: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
  },
  subtleButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#334155",
    padding: "8px 14px",
    fontSize: "12px",
    fontWeight: 700,
  },
  modalPrimaryButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "none",
    background: "linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)",
    color: "#ffffff",
    padding: "8px 15px",
    fontSize: "12px",
    fontWeight: 800,
    boxShadow: "0 12px 24px rgba(37, 99, 235, 0.22)",
  },
  modalPrimaryButtonDisabled: {
    opacity: 0.72,
    cursor: "not-allowed",
    boxShadow: "none",
  },
};

export default function TimeLogs() {
  const usrType = localStorage.getItem("userType");

  const [timeLogInvoices, setTimeLogInvoices] = useState([]);
  const [timeLogs, setTimeLogs] = useState([]);
  const [invType, setInvType] = useState("subcontractor");
  const [entityType, setEntityType] = useState("");
  const [projectStartDate, setProjectStartDate] = useState("");
  const [projectStDt, setProjectStDt] = useState("");
  const [currentStDt, setCurrentStDt] = useState("");
  const [notesType, setNotesType] = useState(
    usrType === "recruiter" ? "TimeLogRecruiter" : "TimeLog"
  );
  const [showHide, setShowHide] = useState(false);
  const [timeLogPopupMode, setTimeLogPopupMode] = useState("calendar");
  const [noteShowHide, setNoteShowHide] = useState(false);
  const [payShowHide, setPayShowHide] = useState(false);
  const [showHideTimeLog, setShowHideTimeLog] = useState(false);
  const [reportShowHide, setReportShowHide] = useState(false);
  const [reportPdfLoading, setReportPdfLoading] = useState(false);
  const [timeLogObj, setTimeLogObj] = useState(null);
  const [reportTimeLogObj, setReportTimeLogObj] = useState(null);
  const [candidateObj, setCandidateObj] = useState(null);
  const [appAllTasks, setAllAppTasks] = useState([]);
  const [allRates, setAllRates] = useState([]);

  const timeLogsSelector = useSelector(getTimeLogs);
  const timeLogInvoiceSelector = useSelector(getTimeLogInvoice);
  const timeLogDurationSelector = useSelector(getTimeLogDuration);
  const allRatesSelector = useSelector(getAllRates);
  const timeLogReportStatusSelector = useSelector(getTimeLogReportStatus);
  const updateStatusSelector = useSelector(getProjectDateUpdateStatus);
  const userDetailsSelector = useSelector(getLoggedUserDetails);
  const timeSheetDelStatusSelector = useSelector(getTimeSheetDelStatus);
  const candidateAppAllTasksSelector = useSelector(getCandidateAppAllTasks);

  const [handleDownloadFile] = useDocDownload();

  const currentUser = getCurrentUser();
  const userId = currentUser?.id;
  const dispatch = useDispatch();

  // RTK Query Hooks
  const { data: timeLogsQueryData = [], refetch: refetchTimeLogs } = useLoadTimeLogsQuery(userId, { skip: !userId || !entityType });
  const { data: timeLogInvoiceQueryData = [] } = useLoadTimeLogInvoiceQuery(userId, { skip: !userId || !entityType });
  const { data: timeLogDurationQueryData = null } = useLoadTimeLogDurationQuery(userId, { skip: !userId || !entityType });
  const { data: allRatesQueryData = [] } = useLoadAllRatesQuery(userId, { skip: !userId || !entityType });

  const [updateProjectStartDateMut] = useUpdateProjectStartDateMutation();
  const [deleteTimeSheetDocMut] = useDeleteTimeSheetDocMutation();
  const [setTimeLogReportStatusMut] = useSetTimeLogReportStatusMutation();

  useEffect(() => {
    if (userId && !userDetailsSelector) {
      dispatch(loadUserDetails(userId));
    }
  }, [dispatch, userId, userDetailsSelector]);

  useEffect(() => {
    if (userDetailsSelector) {
      const cnObj = userDetailsSelector;
      const entityType = getFieldData(
        cnObj.performerData,
        "candidateonboardingform",
        "CandidateEntity"
      );
      setCandidateObj(cnObj);
      setEntityType(entityType);
    }
  }, [userDetailsSelector]);

  useEffect(() => {
    setAllAppTasks(candidateAppAllTasksSelector);
  }, [candidateAppAllTasksSelector]);

  useEffect(() => {
    setAllRates(allRatesSelector);
  }, [allRatesSelector]);

  useEffect(() => {
    setTimeLogs(
      [...timeLogsSelector].sort((a, b) => {
        const yearDiff = Number(b.year || 0) - Number(a.year || 0);
        if (yearDiff !== 0) return yearDiff;
        return Number(b.month || 0) - Number(a.month || 0);
      })
    );
    if (timeLogInvoiceSelector.length > 0) {
      let invoType = invType;
      if (usrType === "candidate") invoType = usrType;
      if (usrType === "candidate" && entityType === "C2C Basis")
        invoType = "subcontractor";
      const filterInvoices = timeLogInvoiceSelector.filter(
        (x) => x.invoiceType === invoType
      );
      setTimeLogInvoices(filterInvoices);
    }
    if (timeLogDurationSelector?.startDate) {
      const startDate = new Date(timeLogDurationSelector.startDate);
      startDate.setDate(startDate.getDate()); // add 1 day
      const result = startDate.toISOString().substring(0, 10);
      setProjectStDt(startDate);
      setCurrentStDt(timeLogDurationSelector.projectStartedDate);
    }
  }, [timeLogsSelector, timeLogInvoiceSelector, timeLogDurationSelector, invType, usrType, entityType]);

  useEffect(() => {
    if (updateStatusSelector) {
      getAlert("", "Saved Successfully", "success");
    }
  }, [updateStatusSelector]);

  useEffect(() => {
    if (timeLogReportStatusSelector && reportTimeLogObj?.id) {
      setTimeLogs((prevTimeLogs) =>
        prevTimeLogs.map((item) =>
          item.id === reportTimeLogObj.id ? { ...item, status: true } : item
        )
      );
      setReportTimeLogObj((prevReportTimeLogObj) =>
        prevReportTimeLogObj ? { ...prevReportTimeLogObj, status: true } : prevReportTimeLogObj
      );
    }
  }, [timeLogReportStatusSelector, reportTimeLogObj]);

  const getInvoiceStatus = (item) => {
    const tmLogs = timeLogInvoices.filter(
      (x) => x.timeLogId === item.id && x.status !== null
    );
    if (tmLogs.length === 0) {
      return (
        <span style={{ ...TIME_LOG_STYLES.statusPill, ...TIME_LOG_STYLES.statusPending }}>
          <i className="fa fa-clock-o" aria-hidden="true"></i>
          Review Pending
        </span>
      );
    }

    return (
      <>
        {tmLogs.map((inv, index) => (
          <div key={index} style={TIME_LOG_STYLES.statusStack}>
            <span style={{ ...TIME_LOG_STYLES.statusPill, ...TIME_LOG_STYLES.statusReviewed }}>
              <i className="fa fa-eye" aria-hidden="true"></i>
              Reviewed
            </span>
            {inv.status === true && (
              <span style={{ ...TIME_LOG_STYLES.statusPill, ...TIME_LOG_STYLES.statusApproved }}>
                <i className="fa fa-check" aria-hidden="true"></i>
                Approved
              </span>
            )}
            {inv.status === false && (
              <span style={{ ...TIME_LOG_STYLES.statusPill, ...TIME_LOG_STYLES.statusRejected }}>
                <i className="fa fa-times" aria-hidden="true"></i>
                Rejected
              </span>
            )}
            <span style={TIME_LOG_STYLES.statusDate}>
              <Moment format="MMM Do YYYY">{inv.reviewDateTime}</Moment>
            </span>
          </div>
        ))}
      </>
    );
  };

  const getPaymentStatus = (item) => {
    const tmLogs = timeLogInvoices.filter((x) => x.timeLogId === item.id);

    if (tmLogs.length === 0) return "";
    return (
      <>
        {tmLogs.map((pay, index) => (
          <div key={index} style={TIME_LOG_STYLES.paymentBlock}>
            {pay.paymentMode && (
              <>
                {pay.docList?.map((doc) => (
                  <button
                    key={doc.id}
                    className="btn btn-sm btn-link p-0 text-underline"
                    onClick={() => handleDownloadFile(doc)}
                  >
                    {doc.documentName}
                  </button>
                ))}
                <div style={TIME_LOG_STYLES.paymentDate}>
                  <Moment format="MMM Do YYYY">{pay.paymentDate}</Moment>
                  <br />
                  <Moment format="h:mm a">{pay.paymentDate}</Moment>
                </div>
                {entityType === "W2 Basis" && (
                  <div style={TIME_LOG_STYLES.paymentText}>
                    Deduction:{" "}
                    {pay?.adpDeduction ? (
                      <RateEncryptDecrypt rateData={pay.adpDeduction} />
                    ) : (
                      "$0.00/Hr"
                    )}
                  </div>
                )}
                <div style={TIME_LOG_STYLES.paymentText}>
                  Paid :{" "}
                  {pay?.paidAmount ? (
                    <RateEncryptDecrypt rateData={pay.paidAmount} />
                  ) : (
                    "$0.00/Hr"
                  )}
                </div>
              </>
            )}
          </div>
        ))}
      </>
    );
  };

  const getPerDiemStatus = (item) => {
    const prd = getFieldData(
      candidateObj?.performerData,
      "candidateonboardingform",
      "Per_Diem_Rate"
    );

    if (!prd) {
      return (
        <>
          NA
          <br />
          NA
        </>
      );
    }

    return (
      <>
        {/* {prd} */}
        <RateEncryptDecrypt rateData={prd} />
        <br />
        {/* {prd * getTotalDays(item.workingHrs)} */}
        <RateEncryptDecrypt rateData={prd * getTotalDays(item.workingHrs)} endSymbol="" />
      </>
    );
  };

  const getTimeLogStatus = (item) => {
    if (canUploadTimesheet(item)) {
      return (
        <div style={TIME_LOG_STYLES.actionStack}>
          <button
            type="button"
            style={TIME_LOG_STYLES.actionLink}
            onClick={() => handleShowHide(item, "calendar")}
          >
            <i className="fa fa-pencil" aria-hidden="true"></i>
            Edit
          </button>
        </div>
      );
    }

    // Approved & paid → no action
    return null;
  };


  const getMonthlyPeriod = (obj) => {
    if (!obj?.workingHrs) return "";

    let wt;
    try {
      wt = JSON.parse(obj.workingHrs);
    } catch (e) {
      return "";
    }

    if (!Array.isArray(wt) || wt.length === 0) return "";

    const sortWt = [...wt].sort(
      (a, b) => new Date(a.start) - new Date(b.start)
    );

    const first = sortWt[0];
    const last = sortWt[sortWt.length - 1];

    const lastDate =
      last.type === "m"
        ? getMonthLastDay(last.start)
        : last.start;

    return (
      <div>
        <Moment format="MM/DD/YYYY">{first.start}</Moment>
        <br />
        <Moment format="MM/DD/YYYY">{lastDate}</Moment>
      </div>
    );
  };

  const handleNotesComments = (type, obj) => {
    if (type === "save") {
      setTimeLogObj(null);
      setNoteShowHide(false);
    } else {
      setTimeLogObj(obj);
      setNoteShowHide(!noteShowHide);
    }
  };

  const handlePayShowHide = (obj) => {
    setPayShowHide(!payShowHide);
    setTimeLogObj(obj);
  };

  const handleReportTimeLog = (obj) => {
    if (!obj) {
      setReportTimeLogObj(null);
      setReportShowHide(false);
      setReportPdfLoading(false);
      return;
    }

    setReportTimeLogObj(obj);
    setReportShowHide(true);
  };

  const getCandidateName = () =>
    [candidateObj?.performername, candidateObj?.lastName].filter(Boolean).join(" ") ||
    currentUser?.name ||
    "N/A";

  const getCandidateId = () =>
    candidateObj?.maxloans || candidateObj?.performerid || currentUser?.id || "N/A";

  const formatCurrency = (value) => `$${formatAmount(Number(value || 0).toFixed(2))}`;

  const isTimeLogReportGenerated = (item) =>
    item?.status === true || item?.status === "true" || item?.status === 1;

  const canUploadTimesheet = (item) => {
    const invoices = timeLogInvoices.filter((x) => x.timeLogId === item.id);
    const hasPaidAmount = invoices.some((x) => x.paidAmount > 0);
    const hasApprovedInvoice = invoices.some((x) => x.status === true);

    return !hasPaidAmount || !hasApprovedInvoice;
  };

  const getCandidateRate = (item) => {
    const itemYear = parseInt(item?.year, 10);
    const itemMonth = parseInt(item?.month, 10);

    const matchedRate = Array.isArray(allRates)
      ? allRates.reduce((best, rate, index) => {
        if (!itemYear || !itemMonth) return best;

        const effMs = new Date(rate?.candidateEffectiveDate).getTime();
        if (!Number.isFinite(effMs)) return best;

        const eff = new Date(effMs);
        const effYear = eff.getFullYear();
        const effMonth = eff.getMonth() + 1;
        const isApplicable =
          effYear < itemYear || (effYear === itemYear && effMonth <= itemMonth);

        if (!isApplicable) return best;

        if (!best) return { ...rate, index };

        const bestMs = new Date(best?.candidateEffectiveDate).getTime();
        if (effMs > bestMs) return { ...rate, index };
        if (effMs === bestMs && index > best.index) return { ...rate, index };

        return best;
      }, null)
      : null;

    const candidateRate =
      matchedRate?.candidateRate !== null &&
        matchedRate?.candidateRate !== undefined &&
        matchedRate?.candidateRate !== ""
        ? matchedRate.candidateRate
        : candidateObj?.rates?.candidateRate;

    return Number(candidateRate) || 0;
  };

  const getTimeLogReportDetails = (item) => {
    if (!item) {
      return {
        candidateName: "N/A",
        candidateId: "N/A",
        monthYear: "",
        hours: 0,
        hoursLabel: "0h 0m",
        days: 0,
        rate: 0,
        totalCompensation: 0,
        positionTitle: "N/A",
        agencyName: "N/A",
      };
    }

    const hours = Number(getTotalHours(item?.workingHrs) || 0);
    const rate = getCandidateRate(item);
    const monthYear = `${getMonthName(item.month)} ${item.year}`;

    return {
      candidateName: getCandidateName(),
      candidateId: getCandidateId(),
      monthYear,
      hours,
      hoursLabel: formatTotalHours(item?.workingHrs),
      days: getTotalDays(item?.workingHrs),
      rate,
      totalCompensation: hours * rate,
      positionTitle:
        getFieldData(candidateObj?.performerData, "projectengagement", "PositionTitle") ||
        "N/A",
      agencyName:
        getFieldData(candidateObj?.performerData, "projectengagement", "AgencyName") ||
        "N/A",
    };
  };

  const generateTimeLogReportPdf = () => {
    if (!reportTimeLogObj || reportPdfLoading) return;

    setReportPdfLoading(true);
    const previewWindow = window.open("", "_blank");

    if (previewWindow) {
      previewWindow.document.write(
        "<html><head><title>Preparing PDF</title></head><body style='font-family:Arial,sans-serif;padding:24px;color:#334155;'>Preparing PDF preview...</body></html>"
      );
      previewWindow.document.close();
    }

    setTimeout(() => {
      try {
        const report = getTimeLogReportDetails(reportTimeLogObj);
        const doc = new jsPDF("portrait", "pt", "a4");
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();
        const margin = 42;
        const contentWidth = pageWidth - margin * 2;

        doc.setFillColor(239, 246, 255);
        doc.setDrawColor(191, 219, 254);
        doc.roundedRect(margin, 40, contentWidth, 108, 14, 14, "FD");
        doc.setFillColor(37, 99, 235);
        doc.roundedRect(margin + 10, 54, 2, 80, 1, 1, "F");

        doc.setTextColor(15, 23, 42);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(21);
        doc.text("Report Time Log", margin + 24, 78);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(10.5);
        doc.setTextColor(71, 85, 105);
        doc.text("Generated monthly report preview", margin + 24, 102);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(9);
        doc.text(`Generated: ${new Date().toLocaleDateString("en-US")}`, margin + 24, 126);

        doc.setFillColor(255, 255, 255);
        doc.setDrawColor(219, 234, 254);
        const statusPillX = pageWidth - margin - 118;
        const statusPillY = 64;
        const statusPillW = 88;
        const statusPillH = 34;
        const statusText = "GENERATED";
        doc.roundedRect(statusPillX, statusPillY, statusPillW, statusPillH, 17, 17, "FD");
        doc.setTextColor(37, 99, 235);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(9);
        doc.text(
          statusText,
          statusPillX + (statusPillW - doc.getTextWidth(statusText)) / 2,
          statusPillY + 21
        );

        const detailCards = [
          ["Candidate", report.candidateName],
          ["Candidate ID", report.candidateId.toString()],
          ["Position", report.positionTitle],
          ["Agency", report.agencyName],
        ];

        const detailCardW = (contentWidth - 14) / 2;
        const detailCardH = 62;
        const detailStartY = 174;
        detailCards.forEach(([label, value], index) => {
          const cardX = margin + (index % 2) * (detailCardW + 14);
          const cardY = detailStartY + Math.floor(index / 2) * (detailCardH + 14);
          doc.setFillColor(248, 250, 252);
          doc.setDrawColor(226, 232, 240);
          doc.roundedRect(cardX, cardY, detailCardW, detailCardH, 10, 10, "FD");
          doc.setTextColor(100, 116, 139);
          doc.setFont("helvetica", "bold");
          doc.setFontSize(8);
          doc.text(label.toUpperCase(), cardX + 16, cardY + 21);
          doc.setTextColor(15, 23, 42);
          doc.setFontSize(12);
          doc.text(doc.splitTextToSize(value || "N/A", detailCardW - 32), cardX + 16, cardY + 43);
        });

        doc.setFillColor(255, 255, 255);
        doc.setDrawColor(226, 232, 240);
        doc.roundedRect(margin, 342, contentWidth, 244, 14, 14, "FD");

        doc.setTextColor(15, 23, 42);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text(`${entityType === "1099 Basis" ? "1099" : "W2"} - Time Log Reporting`, margin + 20, 374);

        doc.setTextColor(100, 116, 139);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.text(`Selected month time log report for ${report.monthYear}.`, margin + 20, 394);

        const reportCards = [
          ["Month / Year", report.monthYear, [37, 99, 235], "Calendar period"],
          ["Approved Hours", report.hoursLabel, [14, 116, 144], "Logged and approved by client"],
          ["Rate / Hour", formatCurrency(report.rate), [124, 58, 237], "Applicable hourly rate"],
          ["Total Compensation", formatCurrency(report.totalCompensation), [22, 101, 52], "Less applicable Taxes"],
        ];

        const reportCardW = (contentWidth - 54) / 2;
        const reportCardH = 68;
        const reportStartY = 420;
        reportCards.forEach(([label, value, color, hint], index) => {
          const reportCardX = margin + 20 + (index % 2) * (reportCardW + 14);
          const reportCardY = reportStartY + Math.floor(index / 2) * (reportCardH + 16);
          doc.setFillColor(248, 250, 252);
          doc.setDrawColor(226, 232, 240);
          doc.roundedRect(reportCardX, reportCardY, reportCardW, reportCardH, 10, 10, "FD");
          doc.setFillColor(color[0], color[1], color[2]);
          doc.roundedRect(reportCardX + 8, reportCardY + 10, 2, reportCardH - 20, 1, 1, "F");
          doc.setTextColor(100, 116, 139);
          doc.setFont("helvetica", "bold");
          doc.setFontSize(8);
          doc.text(label.toUpperCase(), reportCardX + 17, reportCardY + 20);
          doc.setTextColor(15, 23, 42);
          doc.setFontSize(16);
          doc.text(value, reportCardX + 17, reportCardY + 43);
          doc.setTextColor(100, 116, 139);
          doc.setFont("helvetica", "normal");
          doc.setFontSize(8);
          doc.text(hint, reportCardX + 17, reportCardY + 58);
        });

        doc.setDrawColor(226, 232, 240);
        doc.line(margin, pageHeight - 76, pageWidth - margin, pageHeight - 76);
        doc.setTextColor(100, 116, 139);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);
        doc.text("This report is generated from submitted monthly time log data.", margin, pageHeight - 52);
        doc.text("IPCS Customer Portal", pageWidth - margin - 102, pageHeight - 52);

        const blobUrl = doc.output("bloburl");
        if (previewWindow) {
          previewWindow.location.href = blobUrl;
        } else {
          window.open(blobUrl, "_blank");
        }

        if (!isTimeLogReportGenerated(reportTimeLogObj)) {
          setTimeLogReportStatusMut({ id: reportTimeLogObj.id, updatedBy: userId });
        }
      } finally {
        setReportPdfLoading(false);
      }
    }, 150);
  };

  const handleSaveProjectStartDate = () => {
    updateProjectStartDateMut({ id: userId, date: projectStartDate });
  };

  const handleStartDate = ({ currentTarget }) => {
    setProjectStartDate(currentTarget.value);
  };

  const handleShowHide = useCallback((obj, mode = "calendar") => {
    if (obj === "save") {
      setTimeLogObj("");
      setShowHide(false);
      setTimeLogPopupMode("calendar");
      refetchTimeLogs();
    } else {
      setShowHide(obj === null ? false : true);
      setTimeLogObj(obj);
      setTimeLogPopupMode(mode);
    }
  }, [refetchTimeLogs]);

  const handleDeleteTimeSheetDoc = useCallback(async (id) => {
    const result = await getConfirmAlert(
      "Warning",
      "Are you sure you want to delete this Time Sheet?",
      "warning"
    );
    if (result.isConfirmed) {
      deleteTimeSheetDocMut(id);
    }
  }, [deleteTimeSheetDocMut]);

  useEffect(() => {
    if (timeSheetDelStatusSelector) {
      getAlert("", "Deleted Successfully", "success");
    }
  }, [timeSheetDelStatusSelector]);

  let startDt = projectStartDate;
  if (startDt === "") startDt = new Date();
  let pgTitle = "Time Log Management";
  if (entityType !== "C2C Basis") pgTitle = "Time Log and Payments";
  const totalLoggedHours = timeLogs.reduce(
    (sum, log) => sum + Number(getTotalHours(log?.workingHrs) || 0),
    0
  );
  const formatNumericHours = (hours) => {
    const totalMinutes = Math.round((Number(hours) || 0) * 60);
    const finalHours = Math.floor(totalMinutes / 60);
    const finalMinutes = totalMinutes % 60;

    return `${finalHours}h ${finalMinutes}m`;
  };
  const totalLoggedDays = timeLogs.reduce(
    (sum, log) => sum + Number(getTotalDays(log?.workingHrs) || 0),
    0
  );
  const reviewedLogs = timeLogs.filter((item) =>
    timeLogInvoices.some((x) => x.timeLogId === item.id && x.status !== null)
  ).length;
  const paidLogs = timeLogs.filter((item) =>
    timeLogInvoices.some((x) => x.timeLogId === item.id && x.paidAmount > 0)
  ).length;
  const showReportTimeLogColumn =
    entityType === "W2 Basis" || entityType === "1099 Basis";

  return (
    <React.Fragment>
      <div className="col-md-12 mt-2">
        {/* <li className="list-group-item p-2 mb-2">
          <p className="text-black">
            Enter your daily hours logged for each week and upload the
            completed /signed time sheets. Once you enter the hours and upload
            the time sheet all entities as applicable (except the Agency at
            which you are working) will see it in real-time, and this includes
            your employers/subcontractors, if any.
          </p>
          <p className="text-black mt-2">
            Please ensure to log hours and upload time sheets on time to avoid
            any delays in raising invoices to the Agencies.
          </p>
        </li> */}
        <div className="card shadow-none border" style={TIME_LOG_STYLES.card}>
          <div className="card-header" style={TIME_LOG_STYLES.cardHeader}>
            <div style={TIME_LOG_STYLES.titleRow}>
              <div style={TIME_LOG_STYLES.titleWrap}>
                <span style={TIME_LOG_STYLES.titleIcon}>
                  <i className="fa fa-clock-o" aria-hidden="true"></i>
                </span>
                <div>
                  <div style={TIME_LOG_STYLES.title}>{pgTitle}</div>
                  <p style={TIME_LOG_STYLES.subtitle}>
                    Track submitted time, supporting timesheets, review status, and payments in one place.
                  </p>
                </div>
              </div>
              <div>
                <button
                  className="btn btn-sm"
                  style={TIME_LOG_STYLES.primaryButton}
                  disabled={
                    appAllTasks.filter((x) => x.loanPhase_Desc === "Time Log")
                      .length === 0
                  }
                  onClick={() => handleShowHide("", "calendar")}
                >
                  <i className="fa fa-plus" aria-hidden="true"></i> Add Time Log
                </button>
              </div>
            </div>
          </div>
          <div className="card-body" style={TIME_LOG_STYLES.cardBody}>
            <div style={TIME_LOG_STYLES.statsRow}>
              <div style={TIME_LOG_STYLES.statCard}>
                <div style={TIME_LOG_STYLES.statLabel}>Time Logs</div>
                <div style={TIME_LOG_STYLES.statValue}>{timeLogs.length}</div>
                <div style={TIME_LOG_STYLES.statHint}>Submitted time log periods currently available.</div>
              </div>
              <div style={TIME_LOG_STYLES.statCard}>
                <div style={TIME_LOG_STYLES.statLabel}>Total Hours</div>
                <div style={TIME_LOG_STYLES.statValue}>{formatNumericHours(totalLoggedHours)}</div>
                <div style={TIME_LOG_STYLES.statHint}>Combined hours logged across all visible periods.</div>
              </div>
              <div style={TIME_LOG_STYLES.statCard}>
                <div style={TIME_LOG_STYLES.statLabel}>Total Days</div>
                <div style={TIME_LOG_STYLES.statValue}>{totalLoggedDays}</div>
                <div style={TIME_LOG_STYLES.statHint}>Working days recorded from submitted time logs.</div>
              </div>
              <div style={TIME_LOG_STYLES.statCard}>
                <div style={TIME_LOG_STYLES.statLabel}>Reviewed / Paid</div>
                <div style={TIME_LOG_STYLES.statValue}>{reviewedLogs} / {paidLogs}</div>
                <div style={TIME_LOG_STYLES.statHint}>Periods reviewed by IPCS and periods with payment activity.</div>
              </div>
            </div>
            <div style={TIME_LOG_STYLES.utilityRow}>
              <div style={TIME_LOG_STYLES.utilityPanel}>
                <div style={TIME_LOG_STYLES.utilityPanelTop}>
                  <span style={TIME_LOG_STYLES.utilityIcon}>
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                  </span>
                  <div style={TIME_LOG_STYLES.utilityCopy}>
                    <div style={TIME_LOG_STYLES.utilityLabel}>Date Started On The Project</div>
                    <div style={TIME_LOG_STYLES.utilityValue}>
                      {projectStDt !== ""
                        ? new Date(projectStDt).toISOString().substring(0, 10)
                        : new Date(startDt).toISOString().substring(0, 10)}
                    </div>
                  </div>
                </div>
                {projectStDt !== "" ? (
                  <div style={TIME_LOG_STYLES.utilityActions}>
                    <button
                      className="btn btn-sm btn-outline-default"
                      style={TIME_LOG_STYLES.utilityButton}
                      disabled={
                        appAllTasks.filter((x) => x.loanPhase_Desc === "Time Log")
                          .length === 0
                      }
                      onClick={() => setProjectStDt("")}
                    >
                      <i className="fa fa-edit" aria-hidden="true"></i> Edit
                    </button>
                  </div>
                ) : (
                  <div style={TIME_LOG_STYLES.utilityEditor}>
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      style={TIME_LOG_STYLES.utilityInput}
                      value={new Date(startDt).toISOString().substring(0, 10)}
                      onChange={handleStartDate}
                    />
                    <button
                      className="btn btn-sm btn-outline-default mr-0"
                      style={{ ...TIME_LOG_STYLES.utilityButton, ...TIME_LOG_STYLES.utilityPrimaryButton }}
                      onClick={handleSaveProjectStartDate}
                    >
                      <i className="fa fa-check" aria-hidden="true"></i> Save
                    </button>
                    <button
                      className="btn btn-sm btn-outline-default"
                      style={{ ...TIME_LOG_STYLES.utilityButton, ...TIME_LOG_STYLES.utilityDangerButton }}
                      onClick={() => setProjectStDt(currentStDt)}
                    >
                      <i className="fa fa-times" aria-hidden="true"></i> Cancel
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="table-responsive" style={TIME_LOG_STYLES.tableWrap}>
              <table className="table table-hover align-items-center" style={TIME_LOG_STYLES.table}>
                <thead>
                  <tr>
                    <th style={TIME_LOG_STYLES.tableHeadCell}>
                      Month / Year
                      <span style={TIME_LOG_STYLES.tableHeadSubtext}>Report Period</span>
                    </th>
                    <th style={TIME_LOG_STYLES.tableHeadCell}>
                      Period
                      <span style={TIME_LOG_STYLES.tableHeadSubtext}>Time Logged</span>
                    </th>
                    <th style={TIME_LOG_STYLES.tableHeadCell}>
                      Hours
                      <span style={TIME_LOG_STYLES.tableHeadSubtext}>Days</span>
                    </th>
                    <th style={TIME_LOG_STYLES.tableHeadCell}>
                      Approved
                      <span style={TIME_LOG_STYLES.tableHeadSubtext}>Timesheets</span>
                    </th>

                    {entityType !== "W2 Basis" && <th style={TIME_LOG_STYLES.tableHeadCell}>Status</th>}

                    <th style={TIME_LOG_STYLES.tableHeadCell}>
                      Review Status
                    </th>

                    {(entityType === "W2 Basis" || entityType !== "C2C Basis") && (
                      <th style={TIME_LOG_STYLES.tableHeadCell}>
                        PAYMENT
                      </th>
                    )}

                    {entityType === "W2 Basis" && (
                      <th style={TIME_LOG_STYLES.tableHeadCell}>
                        Per Diem Rate
                        <span style={TIME_LOG_STYLES.tableHeadSubtext}>Amount ($)</span>
                      </th>
                    )}

                    <th style={TIME_LOG_STYLES.tableHeadCell}>Action</th>
                    {showReportTimeLogColumn && (
                      <th style={TIME_LOG_STYLES.tableHeadCell}>Report Time Log</th>
                    )}
                  </tr>
                </thead>

                <tbody>
                  {timeLogs.map((item) => (
                    <tr key={item.id}>
                      <td style={TIME_LOG_STYLES.cell}>
                        <span style={TIME_LOG_STYLES.monthYearStack}>
                          <span style={TIME_LOG_STYLES.monthYearPrimary}>
                            {getMonthName(item.month)}
                          </span>
                          <span style={TIME_LOG_STYLES.monthYearSecondary}>
                            {item.year}
                          </span>
                        </span>
                      </td>

                      <td style={TIME_LOG_STYLES.cell}>
                        <button
                          type="button"
                          style={TIME_LOG_STYLES.periodText}
                          onClick={() => handleShowHide(item, "calendar")}
                        >
                          <i className="fa fa-calendar-o" aria-hidden="true" style={TIME_LOG_STYLES.periodIcon}></i>
                          <span>{getMonthlyPeriod(item)}</span>
                        </button>
                      </td>

                      <td style={TIME_LOG_STYLES.cell}>
                        <button
                          type="button"
                          style={TIME_LOG_STYLES.metricButton}
                          onClick={() => handleShowHide(item, "calendar")}
                        >
                          <span style={TIME_LOG_STYLES.metricPrimary}>
                            <i className="fa fa-clock-o" aria-hidden="true"></i>
                            {formatTotalHours(item?.workingHrs)}
                          </span>
                          <span style={TIME_LOG_STYLES.metricSecondary}>
                            {getTotalDays(item.workingHrs)}{" "}
                            {getTotalDays(item.workingHrs) > 1 ? "Days" : "Day"}
                          </span>
                        </button>
                      </td>

                      {/* Approved Timesheets */}
                      <td style={TIME_LOG_STYLES.cell}>
                        <ul style={TIME_LOG_STYLES.docList}>
                          {item.docList?.map((doc) => {
                            const isLocked = timeLogInvoices.some(
                              (x) => x.timeLogId === item.id && x.status === true
                            );

                            return (
                              <li key={doc.id} style={TIME_LOG_STYLES.docRow}>
                                <button
                                  type="button"
                                  style={TIME_LOG_STYLES.docLink}
                                  onClick={() => handleDownloadFile(doc)}
                                >
                                  {doc.documentName}
                                </button>

                                <button
                                  type="button"
                                  style={TIME_LOG_STYLES.iconButton}
                                  title="Delete Timesheet"
                                  disabled={isLocked}
                                  onClick={() => handleDeleteTimeSheetDoc(doc.id)}
                                >
                                  <i className="fa fa-trash text-dark" />
                                </button>
                              </li>
                            );
                          })}
                        </ul>
                        {canUploadTimesheet(item) && (
                          <button
                            type="button"
                            style={{
                              ...TIME_LOG_STYLES.docUploadButton,
                              marginTop: item.docList?.length ? "10px" : 0,
                            }}
                            onClick={() => handleShowHide(item, "documents")}
                          >
                            <i className="fa fa-upload" aria-hidden="true"></i>
                            Upload
                          </button>
                        )}
                      </td>

                      {entityType !== "W2 Basis" && (
                        <td style={TIME_LOG_STYLES.cell}>{getInvoiceStatus(item)}</td>
                      )}

                      {/* Notes */}
                      <td style={TIME_LOG_STYLES.cell}>
                        <button
                          type="button"
                          style={TIME_LOG_STYLES.notesButton}
                          onClick={() => handleNotesComments("", item)}
                        >
                          <i className="fa fa-commenting-o" aria-hidden="true"></i>
                          View
                          <span style={TIME_LOG_STYLES.notesBadge}>
                            {
                              item?.allComments?.filter(
                                (x) => x.commentType === notesType
                              ).length
                            }
                          </span>
                        </button>
                      </td>

                      {entityType !== "C2C Basis" && (
                        <td style={TIME_LOG_STYLES.cell}>{getPaymentStatus(item)}</td>
                      )}

                      {entityType === "W2 Basis" && (
                        <td style={TIME_LOG_STYLES.cell}>{getPerDiemStatus(item)}</td>
                      )}

                      <td style={TIME_LOG_STYLES.cell}>{getTimeLogStatus(item)}</td>
                      {showReportTimeLogColumn && (
                        <td style={TIME_LOG_STYLES.cell}>
                          <button
                            type="button"
                            style={{
                              ...TIME_LOG_STYLES.reportButton,
                              ...(isTimeLogReportGenerated(item)
                                ? TIME_LOG_STYLES.reportGeneratedButton
                                : {}),
                            }}
                            onClick={() => handleReportTimeLog(item)}
                          >
                            <i
                              className={
                                isTimeLogReportGenerated(item)
                                  ? "fa fa-check-circle"
                                  : "fa fa-cog"
                              }
                              aria-hidden="true"
                            ></i>
                            {isTimeLogReportGenerated(item) ? "Generated" : "Generate"}
                          </button>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </div>

      <AddNewTimeLog
        showHide={showHide}
        handleShowHide={handleShowHide}
        selectedObj={timeLogObj}
        popupMode={timeLogPopupMode}
        timeLogInvoices={timeLogInvoices}
        allTimeLogs={timeLogsSelector}
        candidateObj={candidateObj}
        projectStartDate={projectStDt}
      ></AddNewTimeLog>

      <AddEditNotes
        noteShowHide={noteShowHide}
        handleNoteShowHide={handleNotesComments}
        notesType={notesType}
        candidateObj={candidateObj}
        timeLogObj={timeLogObj}
      ></AddEditNotes>

      <CandidatePay
        payShowHide={payShowHide}
        handlePayShowHide={handlePayShowHide}
        selectedObj={timeLogObj}
        candidateObj={candidateObj}
      ></CandidatePay>

      <Modal
        show={reportShowHide}
        size="lg"
        centered
        onHide={() => handleReportTimeLog(null)}
      >
        <Modal.Header style={TIME_LOG_STYLES.modalHeader}>
          <Modal.Title as="div" style={TIME_LOG_STYLES.modalTitleWrap}>
            <span style={TIME_LOG_STYLES.modalIcon}>
              <i className="fa fa-file-text-o" aria-hidden="true"></i>
            </span>
            <div>
              <h2 style={TIME_LOG_STYLES.modalTitle}>Report Time Log</h2>
              <div style={TIME_LOG_STYLES.modalSubtitle}>
                {reportTimeLogObj
                  ? `${getMonthName(reportTimeLogObj.month)} ${reportTimeLogObj.year}`
                  : ""}
              </div>
            </div>
            <button
              type="button"
              style={TIME_LOG_STYLES.modalCloseButton}
              onClick={() => handleReportTimeLog(null)}
              aria-label="Close report time log popup"
            >
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={TIME_LOG_STYLES.modalBody}>
          {reportTimeLogObj && (
            <>
              {(() => {
                const report = getTimeLogReportDetails(reportTimeLogObj);

                return (
                  <>
                    <div style={TIME_LOG_STYLES.reportSummaryGrid}>
                      <div style={TIME_LOG_STYLES.reportSummaryCard}>
                        <div style={TIME_LOG_STYLES.reportSummaryLabel}>Candidate</div>
                        <div style={TIME_LOG_STYLES.reportSummaryValue}>{report.candidateName}</div>
                      </div>
                      <div style={TIME_LOG_STYLES.reportSummaryCard}>
                        <div style={TIME_LOG_STYLES.reportSummaryLabel}>Candidate ID</div>
                        <div style={TIME_LOG_STYLES.reportSummaryValue}>{report.candidateId}</div>
                      </div>
                      <div style={TIME_LOG_STYLES.reportSummaryCard}>
                        <div style={TIME_LOG_STYLES.reportSummaryLabel}>Position</div>
                        <div style={TIME_LOG_STYLES.reportSummaryValue}>{report.positionTitle}</div>
                      </div>
                      <div style={TIME_LOG_STYLES.reportSummaryCard}>
                        <div style={TIME_LOG_STYLES.reportSummaryLabel}>Agency</div>
                        <div style={TIME_LOG_STYLES.reportSummaryValue}>{report.agencyName}</div>
                      </div>
                    </div>

                    <div style={TIME_LOG_STYLES.reportPreviewCard}>
                      <div style={TIME_LOG_STYLES.reportPreviewHeader}>
                        <h3 style={TIME_LOG_STYLES.reportPreviewTitle}>
                          {entityType === "1099 Basis" ? "1099" : "W2"} - Time Log Reporting
                        </h3>
                        <p style={TIME_LOG_STYLES.reportPreviewSubtitle}>
                          Selected month time log report for {report.monthYear}.
                        </p>
                      </div>
                      <div style={TIME_LOG_STYLES.reportMetricGrid}>
                        <div style={TIME_LOG_STYLES.reportMetricCard}>
                          <span
                            style={{
                              ...TIME_LOG_STYLES.reportMetricAccent,
                              background: "#2563eb",
                            }}
                          />
                          <span
                            style={{
                              ...TIME_LOG_STYLES.reportMetricIcon,
                              color: "#2563eb",
                              background: "#eff6ff",
                            }}
                          >
                            <i className="fa fa-calendar" aria-hidden="true"></i>
                          </span>
                          <div style={TIME_LOG_STYLES.reportMetricLabel}>Month / Year</div>
                          <div style={TIME_LOG_STYLES.reportMetricValue}>{report.monthYear}</div>
                          <span style={TIME_LOG_STYLES.reportMuted}>Calendar period</span>
                        </div>
                        <div style={TIME_LOG_STYLES.reportMetricCard}>
                          <span
                            style={{
                              ...TIME_LOG_STYLES.reportMetricAccent,
                              background: "#0f766e",
                            }}
                          />
                          <span
                            style={{
                              ...TIME_LOG_STYLES.reportMetricIcon,
                              color: "#0f766e",
                              background: "#ecfdf5",
                            }}
                          >
                            <i className="fa fa-clock-o" aria-hidden="true"></i>
                          </span>
                          <div style={TIME_LOG_STYLES.reportMetricLabel}>Approved Hours</div>
                          <div style={TIME_LOG_STYLES.reportMetricValue}>{report.hoursLabel}</div>
                          <span style={TIME_LOG_STYLES.reportMuted}>
                            Logged and approved by client
                          </span>
                        </div>
                        <div style={TIME_LOG_STYLES.reportMetricCard}>
                          <span
                            style={{
                              ...TIME_LOG_STYLES.reportMetricAccent,
                              background: "#7c3aed",
                            }}
                          />
                          <span
                            style={{
                              ...TIME_LOG_STYLES.reportMetricIcon,
                              color: "#7c3aed",
                              background: "#f5f3ff",
                            }}
                          >
                            <i className="fa fa-usd" aria-hidden="true"></i>
                          </span>
                          <div style={TIME_LOG_STYLES.reportMetricLabel}>Rate / Hour</div>
                          <div style={TIME_LOG_STYLES.reportMetricValue}>
                            {formatCurrency(report.rate)}
                          </div>
                          <span style={TIME_LOG_STYLES.reportMuted}>Applicable hourly rate</span>
                        </div>
                        <div style={TIME_LOG_STYLES.reportMetricCard}>
                          <span
                            style={{
                              ...TIME_LOG_STYLES.reportMetricAccent,
                              background: "#15803d",
                            }}
                          />
                          <span
                            style={{
                              ...TIME_LOG_STYLES.reportMetricIcon,
                              color: "#15803d",
                              background: "#f0fdf4",
                            }}
                          >
                            <i className="fa fa-credit-card" aria-hidden="true"></i>
                          </span>
                          <div style={TIME_LOG_STYLES.reportMetricLabel}>Total Compensation</div>
                          <div style={TIME_LOG_STYLES.reportMetricValue}>
                            {formatCurrency(report.totalCompensation)}
                          </div>
                          <span style={TIME_LOG_STYLES.reportMuted}>Less applicable Taxes</span>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })()}
            </>
          )}
        </Modal.Body>
        <Modal.Footer style={TIME_LOG_STYLES.modalFooter}>
          <div style={TIME_LOG_STYLES.modalFooterActions}>
            <button
              type="button"
              className="btn btn-sm mr-2"
              style={{
                ...TIME_LOG_STYLES.modalPrimaryButton,
                ...(reportPdfLoading
                  ? TIME_LOG_STYLES.modalPrimaryButtonDisabled
                  : {}),
              }}
              onClick={generateTimeLogReportPdf}
              disabled={reportPdfLoading}
            >
              <i
                className={`fa ${reportPdfLoading
                  ? "fa-spinner fa-spin"
                  : isTimeLogReportGenerated(reportTimeLogObj)
                    ? "fa-external-link"
                    : "fa-file-pdf-o"
                  }`}
                aria-hidden="true"
              ></i>
              {reportPdfLoading
                ? "Preparing PDF..."
                : isTimeLogReportGenerated(reportTimeLogObj)
                  ? "Preview PDF"
                  : "Generate PDF"}
            </button>
            <button
              type="button"
              className="btn btn-sm"
              style={TIME_LOG_STYLES.subtleButton}
              onClick={() => handleReportTimeLog(null)}
            >
              <i className="fa fa-times" aria-hidden="true"></i> Close
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* <AddTimeLog
        showHideTimeLog={showHideTimeLog}
        handleShowHideTimeLog={handleShowHideTimeLog}
        appTasklist={appTasklist}
        workflowTask={workflowTask}
      ></AddTimeLog> */}
    </React.Fragment>
  );
}
